import { render, staticRenderFns } from "./form-combined.vue?vue&type=template&id=203c7b24&scoped=true&"
import script from "./form-combined.vue?vue&type=script&lang=js&"
export * from "./form-combined.vue?vue&type=script&lang=js&"
import style0 from "./form-combined.vue?vue&type=style&index=0&id=203c7b24&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203c7b24",
  null
  
)

export default component.exports